import { handleActions } from "redux-actions";
import { combineReducers } from "redux";
import {
  getInitDataVpo,
  getInitDataVpoSuccess,
  getInitDataVpoFailure,
  getInitDataVpoIdle,
  setFiltersDate,
} from "../actions";
import { ListFieldsKeys, ListFieldsRecordType, ListFieldsType } from "src/api/config";
import { Status } from "src/modules/modules.type";
import { PayloadAction } from "@reduxjs/toolkit";
import { data_get_actionData, status_get_actionData } from "./actionDataReducers";
import { data_get_actionsData, status_get_actionsData } from "./actionsDataReducers";
import { set_end_questionary_data, set_end_questionary_status } from "./setEndQuestionaryReducers";
import { status_copy_prev_month } from "./copyPrevMonthReducers";
import { data_set_condition, status_set_condition } from "./setConditionReducers";
import { data_get_report_factory, status_get_report_factory } from "./getReportFactorySaga";
import { data_get_report_completed_actions, status_get_report_completed_actions } from "./getReportCompletedActionsSaga";
import { data_get_report_summary, status_get_report_summary } from "./getReportSummaryReducers";
import { set_return_questionary_data, set_return_questionary_status } from "./setReturnQuestionaryReducers";
import { set_status_questionary_status } from "./setStatusQuestionaryReducers";
import { data_get_report_actions, status_get_report_actions } from "./getReportActionsReducers";

interface GetItemsRequestProps {
  count: number;
  ID: number;
  listName: ListFieldsKeys;
  nextPage?: boolean;
  merge?: boolean;
  items?: ListFieldsType[ListFieldsKeys][];
  body?: any;
  start?: boolean;
  update?: boolean;
  delete?: boolean;
  contentType?: string;
  filters?: any;
}

const initialItemsState: Partial<Record<ListFieldsKeys, number[]>> = {};

const items = handleActions(
  {
    [getInitDataVpo.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (action.payload && action.payload.contentType && !state[action.payload.contentType]) {
        return { ...state, [action.payload.contentType]: [] };
      } else if (
        action.payload &&
        action.payload.contentType &&
        state[action.payload.contentType] &&
        !action.payload.nextPage &&
        !action.payload.merge
      ) {
        return { ...state, [action.payload.contentType]: [] };
      } else {
        return state;
      }
    },
    [getInitDataVpoSuccess.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (action.payload && action.payload.contentType && action.payload.items) {
        const contentType = action.payload.contentType;
        const currentList = state[contentType] || [];
        const newItems: number[] = action.payload.items.map((item) => item.ID) || [];

        let stateItems = [];

        if (action.payload.merge) {
          if (action.payload.start) {
            stateItems = [...newItems, ...currentList];
          } else {
            stateItems = [...currentList, ...newItems];
          }
        } else {
          if (action.payload.update) {
            stateItems = [...currentList];
          } else {
            stateItems = [...newItems];
          }
        }

        if (action.payload.delete) {
          let removeID = newItems[0] || null;
          if (removeID) {
            let newDataCurrentList: any = [];
            newDataCurrentList = [...currentList.filter((item: any) => item !== removeID)];
            stateItems = [...newDataCurrentList];
          } else {
            stateItems = [...currentList];
          }
        }

        return {
          ...state,
          [contentType]: stateItems,
        };
      } else {
        return state;
      }
    },
  },
  initialItemsState
);


const initialObjState: Partial<Record<ListFieldsKeys, Record<number, ListFieldsRecordType[ListFieldsKeys]>>> = {};
// Пример возможного действия после успешного обновления элемента

const obj = handleActions(
  {
    [getInitDataVpo.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (action.payload && action.payload.contentType && !state[action.payload.contentType]) {
        return { ...state, [action.payload.contentType]: {} };
      } else if (
        action.payload &&
        action.payload.contentType &&
        state[action.payload.contentType] &&
        !action.payload.nextPage &&
        !action.payload.merge
      ) {
        return { ...state, [action.payload.contentType]: {} };
      } else {
        return state;
      }
    },
    [getInitDataVpoSuccess.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (action.payload && action.payload.contentType && action.payload.items) {
        const newItems: number[] = action.payload.items.map((item) => item.ID) || [];
        let itemsObj: any = {};

        action.payload.items.forEach((item) => {
          itemsObj[item.ID] = item;
        });

        let stateObj: any = {};

        if (action.payload.merge || action.payload.update) {
          stateObj = { ...state[action.payload.contentType], ...itemsObj };
        } else {
          stateObj = { ...itemsObj };
        }

        if (action.payload.delete) {
          let removeID = newItems[0] || null;
          if (removeID) {
            const oldStateListObj: any = { ...state[action.payload.contentType] };
            const newStateListObj: any = {};
            Object.keys(oldStateListObj).map((key) => {
              if (Number(key) !== removeID) {
                newStateListObj[key] = oldStateListObj[key];
              }
            });
            stateObj = { ...newStateListObj };
          }
        }
        return {
          ...state,
          [action.payload.contentType]: stateObj,
        };
      } else {
        return state;
      }
    },
  },
  initialObjState
);

const filters = handleActions(
  {
    [setFiltersDate.toString()]: (state, action) => {
      // console.log('date-filters', action);
      return {
        ...state,
        Date: action.payload
      }
    },
    [getInitDataVpoSuccess.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (action.payload && action.payload.contentType && action.payload.items) {
        let itemsObj: any = {
          ...action.payload.filters
        };
        return {
          ...state,
          [action.payload.contentType]: itemsObj,
        };
      } else {
        return state;
      }
    },
  },
  initialObjState
);

const elements = combineReducers({
  items,
  obj,
  filters
});

const initStatus: Partial<Record<ListFieldsKeys, Status>> = {};

const getStatus = handleActions(
  {
    [getInitDataVpoSuccess.toString()]: (state: any, action) => {
      if (action.payload && action.payload.contentType) {
        return {
          ...state,
          [action.payload.contentType]: "SUCCESS",
        };
      } else {
        return state;
      }
    },
    [getInitDataVpo.toString()]: (state, action) => {
      if (action.payload && action.payload.contentType) {
        return {
          ...state,
          [action.payload.contentType]: "LOADING",
        };
      } else {
        return state;
      }
    },
    [getInitDataVpoFailure.toString()]: (state, action) => {
      if (action.payload && action.payload.contentType) {
        return {
          ...state,
          [action.payload.contentType]: "FAILURE",
        };
      } else {
        return state;
      }
    },
    [getInitDataVpoIdle.toString()]: (state, action) => {
      if (action.payload && action.payload.contentType) {
        return {
          ...state,
          [action.payload.contentType]: "IDLE",
        };
      } else {
        return state;
      }
    },
  },
  initStatus
);

const vpo = combineReducers({
  elements,
  getStatus,
  status_set_condition,
  data_set_condition,
  status_get_actionData,
  data_get_actionData,
  status_get_actionsData,
  data_get_actionsData,
  set_end_questionary_data,
  set_end_questionary_status,
  status_copy_prev_month,
  status_get_report_factory,
  data_get_report_factory,
  status_get_report_completed_actions,
  data_get_report_completed_actions,
  data_get_report_summary,
  status_get_report_summary,
  set_return_questionary_status,
  set_return_questionary_data,
  set_status_questionary_status,
  status_get_report_actions,
  data_get_report_actions,
});

export { vpo };
